import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { DeleteOutlined,RollbackOutlined } from "@ant-design/icons";
import dateFormat from "dateformat";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";

import {
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateInvoiceItem,
  deleteInvoiceItem,
  getSpecificInvoice,
  updateService,
  deleteService,
} from "../../../actions/invoiceItem";
import { getdeliverytype } from "../../../actions/settings";
import { updateVariation } from "../../../actions/variableProductAction";
// import EditMeasurement from "./EditMeasurement";
import {
  getSpecificContact,
  updateContact,
} from "../../../actions/contactAction";
import { getAllAccount } from "../../../actions/accountsAction";
import { getInvoiceMeasurement } from "../../../actions/measurment";
import { getSpecificMeasurementbycontact } from "../../../actions/measurment";

import InvoiceItem from "./InvoiceItem";
import AddToExchange from "./AddToExchange";
// import AddService from "./AddServiceToUpdate";
// import Addpackagingtoupdate from "../../Addpackagingtoupdate";
import Log from "./Log";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
  DatePicker,
  Spin,
} from "antd";
import { values } from "@antv/util";

const { Option } = Select;

const Quickview = ({
  invoice,
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateVariation,
  updateInvoiceItem,
  deleteInvoiceItem,
  getdeliverytype,
  getAllAccount,
  courier,
  getSpecificInvoice,
  updateService,
  deleteService,
  getInvoiceMeasurement,
  getSpecificMeasurementbycontact,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [fullpageloading, setfullpageloading] = useState(false);
  const [accounts, setaccounts] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [initialmeasurements, setinitialmeasurements] = useState({});
  const packagingItems = useRef([]);
  const bill = useRef();
  const [cart, setcart] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [data, setdata] = useState();
  const [services, setservices] = useState();
  const [deliverymethod, setdeliverymethod] = useState([]);
  const [form] = Form.useForm();
  const loaddata = useRef(false);
  const initialdata = useRef();
  
  let details = {};
  const Wallet = useRef({
    Bill: 0,
    Due: 0,
    Payment: 0,
    Advance: 0,
    PaymentMethod: 0,
    VAT: 0,
    Discount: 0,
    Cupon: null,
    DiscountLimit: 10000,
    Quantity: 0,
  });

  useEffect(() => {
    if (visible) {
      // setloading(true);
      getdeliverytype().then((delivery) => {
        setdeliverymethod(delivery);
      });
      getAllAccount().then((acc) => {
        setaccounts(acc);
      });

      getSpecificInvoice(invoice.id).then((result) => {
        getSpecificMeasurementbycontact(result.contact.id).then((res) => {
          if (typeof res != "undefined") {
            setinitialmeasurements(res);
          }
        });
        if (result.delivery_date != null && result.delivery_date != undefined) {
          result.delivery_date = moment(result.delivery_date);
        }

        form.setFieldsValue(result);
        initialdata.current = result;
        details = { ...result };
        Wallet.current.Bill = details.bill;
        Wallet.current.Due = details.due;
        Wallet.current.Payment = details.payment;
        Wallet.current.Discount = details.discount;
        Wallet.current.DiscountLimit = details.discountlimit;
        Wallet.current.VAT = details.tax;
        Wallet.current.Advance = details.advance_payment;
        Wallet.current.Cupon = details.cupon;
        Wallet.current.Quantity = details.quantity;
        bill.current = 0;
        console.log(initialdata.current)
        console.log(Wallet.current)
        getInvoiceMeasurement(invoice.id).then((response) => {
          setmeasurements(response);
          getInvoiceItem(invoice.id).then((items) => {
            getServices(invoice.id).then((services) => {
              setdata(items);
              setservices(services);
              setloading(false);
            });
          });
        });

        setrefresh(false);
      });
    }
  }, [refresh, visible]);

  const onFinish = (values) => {
    setfullpageloading(true);
    console.log(values);
    values.status = "Exchanged";
    
    if (values.delivery_date != null && values.delivery_date != undefined) {
      values.delivery_date = values.delivery_date.format("yyyy-MM-DD");
    }

    if (values.paymentt > 0) {
      values.payment =
        parseFloat(Wallet.current.Payment) + parseFloat(values.paymentt);
      values.due = parseFloat(Wallet.current.Due) - parseFloat(values.paymentt);
    }
    if (values.account == 1) {
      values.Payment_method = "Cash";
    } else {
      for (let i = 0; i < accounts.length; i++) {
        if (accounts[i].id == values.account) {
          values.Payment_method = accounts[i].type;
        }
      }
    }

    updateInvoice(invoice.id, values).then((result) => {
      if (result) {
        setVisible(false);
        form.resetFields();
        window.location.reload();
      }
    });
  };

  const showDrawer = () => {
    setVisible(true);
    form.resetFields();
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  const QuantityUpdate = (value, data) => {
    console.log("on page load");
    let diff = data.quantity - value;
    let mainproduct = data.Product[0].quantity + diff;
    console.log("wordrobe : " + value + " main stock : " + mainproduct);
    let formData = new FormData();
    formData.append("quantity", value);
    formData.append("data", "");
    updateInvoiceItem(data.id, formData);
    formData = new FormData();
    formData.append("quantity", mainproduct);
    formData.append("data", "");
    updateVariation(data.Product[0].id, formData).then((e) => {
      setloading(true);
      setrefresh(true);
    });
  };

  const ServiceUpdate = (quantity, price, data) => {
    let formData = new FormData();
    formData.append("quantity", quantity);
    formData.append("price", price);
    formData.append("data", "");
    updateService(data.id, formData).then((e) => {
      setloading(true);
      setrefresh(true);
    });
  };

  const invoiceitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((data, index) => {
        console.log(data)
        return (
          <>
            <Row
              style={{
                borderRadius: "5px",
                padding: "10px",

                border: "1px solid gray",
                marginBottom: "5px",
              }}
            >
              <Col span={14} style={{ margin: "auto" }}>
                {index + 1}. {data.Details}{" "}
                <br />
                {data.Product[0].Warehouse_name}
              </Col>
              <Col span={4}>
                {data.Product ? (
                  <InputNumber
                    min={1}
                    value={data.quantity}
                    defaultValue={data.quantity}
                    max={data.quantity + data.Product[0].quantity}
                    onChange={(value) => {
                      // setloading(true);
                      // setrefresh(true);
                      if (value != null) {
                        QuantityUpdate(value, data);
                      }
                    }}
                  ></InputNumber>
                ) : (
                  data.quantity
                )}
              </Col>
              <Col span={5} style={{ textAlign: "center", margin: "auto" }}>
                {data.price}
                {data.Product ? (
                  <RollbackOutlined 
                    style={{ color: "green", float: "right", marginTop: "4px" }}
                    onClick={(e) => {
                      let formData = new FormData();
                      let mainproduct =
                        data.Product[0].quantity + data.quantity;
                      formData.append("quantity", mainproduct);
                      formData.append("data", "");
                      updateVariation(data.Product[0].id, formData);
                      deleteInvoiceItem(data.id).then((rsult) => {
                        // setloading(true);
                        setrefresh(true);
                      });
                    }}
                  />
                ) : (
                  ""
                )}
              </Col>
              
              <Col span={24}>
                {typeof data.Product != "undefined" ? (
                  <>
                  </>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </>
        );
      });
    }
  };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((data, index) => {
        return (
          <>
            <Row
              style={{
                borderRadius: "5px",
                padding: "10px",

                border: "1px solid gray",
                marginBottom: "5px",
              }}
            >
              <Col span={14} style={{ margin: "auto" }}>
                {index + 1}. {data.Details}{" "}
              </Col>
              <Col span={4}>
                {data.Product ? (
                  <InputNumber
                    min={1}
                    value={data.quantity}
                    defaultValue={data.quantity}
                    max={data.quantity + data.Product[0].quantity}
                    onChange={(value) => {
                      setloading(true);
                      // setrefresh(true);
                      if (value != null) {
                        QuantityUpdate(value, data);
                      }
                    }}
                  ></InputNumber>
                ) : (
                  data.quantity
                )}
              </Col>
              <Col span={5} style={{ textAlign: "center", margin: "auto" }}>
                {data.price}
                {data.Product ? (
                  <DeleteOutlined
                    style={{ color: "Red", float: "right", marginTop: "4px" }}
                    onClick={(e) => {
                      let formData = new FormData();
                      let mainproduct =
                        data.Product[0].quantity + data.quantity;
                      formData.append("quantity", mainproduct);
                      formData.append("data", "");
                      updateVariation(data.Product[0].id, formData);
                      deleteInvoiceItem(data.id).then((rsult) => {
                        setloading(true);
                        setrefresh(true);
                      });
                    }}
                  />
                ) : (
                  ""
                )}
              </Col>
              
              <Col span={24}>
                {typeof data.Product != "undefined" ? (
                  <>
                  </>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </>
        );
      });
    }
  };

  const renderData = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={3}>
                  <h3>Invoice No.</h3>
                  {initialdata.current.invoice_number}
                </Col>
                <Col span={3}>
                  <h3>Issue date</h3>
                  {dateFormat(initialdata.current.issue_date, "mmmm dS, yyyy")}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Quantity</h3>
                  {formatter.format(Wallet.current.Quantity)}
                </Col>

                <Col span={3} style={{ textAlign: "center" }}>
                  <h3>Total Bill</h3>
                  {formatter.format(Wallet.current.Bill)}
                </Col>
                <Col span={3} style={{ textAlign: "center" }}>
                  <h3>Payment</h3>
                  {formatter.format(Wallet.current.Payment)}
                </Col>
                <Col span={3} style={{ textAlign: "center" }}>
                  <h3>Due</h3>
                  {formatter.format(Wallet.current.Due)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Discount</h3>
                  {formatter.format(Wallet.current.Discount)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>VAT</h3>
                  {formatter.format(Wallet.current.VAT)}
                </Col>
                <Col span={3} style={{ textAlign: "center" }}>
                  <h3>Coupon</h3>
                  {Wallet.current.Cupon ? Wallet.current.Cupon.name : "-"}
                </Col>
              </Row>
              <Divider />

              <Row>
                <Col span={24}>
                    <Form
                        form={form}
                        onFinish={onFinish}
                        initialValues={initialdata.current}
                        >
                      <Row>    
                      <Col span={16}>
                        
                        <Row>
                            <Col span={11} offset={1} >
                                <Row> <b> Invoice Status </b></Row>
                                <Row>          
                                    <Form.Item
                                        name="status"
                                        // label="Status"
                                        style={{ fontWeight: "400",width: "100%"  }}
                                        rules={[
                                            {
                                            required: true,
                                            message: "Please choose a status",
                                            },
                                        ]}
                                        >
                                        <Select
                                            placeholder="Please choose a status"
                                            style={{ fontWeight: "400",width: "100%"  }}
                                        >
                                            <Option value="Pending">Pending</Option>
                                            {Wallet.current.Due == 0 ? (
                                            <>
                                                <Option value="Delivered">Delivered</Option>
                                                <Option value="Paid">Paid</Option>
                                            </>
                                            ) : (
                                            <></>
                                            )}
                                            <Option value="Exchanged">Exchanged</Option>
                                            <Option value="Cancelled">Cancelled</Option>
                                        </Select>
                                    </Form.Item> 
                                </Row>
                            </Col>    
                            <Col span={11} offset={1} >
                                <Row> <b> Current Location </b></Row>
                                <Row>  
                                  <text style={{color:"green", fontWeight: "400",width: "100%"}}>{initialdata.current.Location_name}</text>  
                                </Row>
                            </Col>         
                        </Row>
                        
                        {/* ########## second row ########### */}
                        <Row>
                              {Wallet.current.Due > 0 ? (
                                <Col span={11} offset={1}>
                                  <Row>  <b>New Payment </b></Row>
                                  <Row>
                                    <>
                                      <Col span={24}>
                                        <Form.Item name="paymentt">
                                          <InputNumber placeholder="Amount" />
                                        </Form.Item>
                                      </Col>
                                    </>
                                  </Row>
                                </Col>  
                                ) : (
                                  ""
                              )}

                          {Wallet.current.Due > 0 ? (
                          <Col span={11} offset={1}>
                            <Row> <b> Payment Method  </b></Row>
                            <Row>
                              <Col span={22}>
                                <Form.Item name="account">
                                  <Select>
                                    {accounts.map((account) => {
                                      return (
                                        <Option value={account.id}>
                                          {account.name}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col> 
                          ) : (
                            ""
                          )}

                          {Wallet.current.Advance > 0 ? (
                          <Col span={12} offset={1}>
                            <Row>
                               <b> Advance Payment</b>
                            </Row>
                            <Row>
                                <>
                                  <Col span={22}>
                                    <Form.Item
                                      name="advance_payment"
                                     
                                    >
                                      <InputNumber disabled max={formatter.format(Wallet.current.Advance)} />
                                    </Form.Item>
                                  </Col>
                                </>
                            </Row>
                            </Col>
                                ) : (
                                ""
                          )}
                        </Row>

                        <Row>
                            <Col span={11} offset={1}>
                              <Row>
                                <b> Product Discount</b>
                              </Row>
                              <Row>
                                  <>
                                    <Col span={24}>
                                      <Form.Item
                                        name="additional_discount"
                                      
                                      >
                                      <InputNumber
                                        // defaultValue={0}
                                        placeholder="Adjustment Amount"
                                      />
                                      </Form.Item>
                                    </Col>
                                  </>
                              </Row>
                            </Col>
                            <Col span={11} offset={1}>
                                <Row>
                                  <Col span={10}><b>Sales Discount </b></Col>
                                  <Col span={12} offset={2}>
                                    <small>
                                    {" "} Max :{" "}
                                        {formatter.format(Wallet.current.DiscountLimit)} BDT
                                    </small>
                                  </Col>
                                   
                                    
                                </Row>
                                <Row> 
                                  {!Wallet.current.Cupon > 0 ? (
                                    <Col span={22}>

                                    <Form.Item name="discount">
                                        <InputNumber
                                        // min={0}
                                        // defaultValue={Wallet.current.Discount}
                                        // max={Wallet.current.DiscountLimit}
                                        placeholder="Amount"
                                        />
                                    </Form.Item>
                                    </Col>
                                    ) : (
                                        <Col span={22}>
                                        <Form.Item name="discountt" label="Discount">
                                            {formatter.format(Wallet.current.Cupon.amount)}
                                            {Wallet.current.Cupon.ref_type == "P"
                                            ? " %"
                                            : " BDT"}
                                        </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                          </Col>   
                        </Row>
                        <Row>
                          <Col span={3} offset={1}>
                            <Button onClick={onClose} type="danger"  style={{ marginRight: 8 }}>
                              Cancel
                            </Button>
                          </Col>
                          <Col span={3}>
                            {initialdata.current.status != "Paid" ? (
                              <Button type="primary" htmlType="submit">
                                Update
                              </Button>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col span={3}>
                            <Log invoiceID={invoice.id} />
                          </Col>
                        </Row>
                      </Col>
                      
                      <Col span={8}>
                        <Row>
                          Remarks
                        </Row>
                        <Row>
                          <Form.Item name="remarks">
                              <ReactQuill theme="snow" preserveWhitespace={true}  />
                          </Form.Item>
                        </Row>
                      </Col>
                      </Row>
                      
                    </Form>
                  </Col>   
              </Row>
              <Divider></Divider>
              <Row>
                

                {/* Invocie Items */}
              <Col
                  span={11}
                  offset={1}
                  style={{
                    padding: "20px",
                    paddingTop: "10px",
                    backgroundColor: "whitesmoke",
                    borderRadius: "10px",
                    minHeight: "60vh",
                  }}
                >
                    <InvoiceItem
                      wordrobeitems={data}
                      setrefresh={setrefresh}
                      details={initialdata.current}
                    />
                    {/* <Divider /> */}
                    <Row
                      style={{
                        borderRadius: "5px",
                        padding: "10px",

                      }}
                    >
                      <Col span={14}>
                        <h3>Product</h3>
                      </Col>
                      <Col span={4}>
                        <h3>Qty</h3>
                      </Col>
                      <Col span={5} style={{ textAlign: "center" }}>
                        <h3>Price</h3>
                      </Col>
                    </Row>
                    {invoiceitems()}
                </Col>

                {/* Add To Exchange */}
                <Col
                  span={11}
                  offset={1}
                  style={{
                    padding: "20px",
                    paddingTop: "10px",
                    backgroundColor: "whitesmoke",
                    borderRadius: "10px",
                    minHeight: "60vh",
                  }}
                > 
                  <AddToExchange
                    wordrobeitems={data}
                    setrefresh={setrefresh}
                    details={initialdata.current}
                  />            
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      );
    }
  };

  return (
    <>
      <>
        <a href="#" onClick={showDrawer} style={{ margin: 4, color:"red" }}>
          Exchange
        </a>
        <Drawer
          title="Invoice Product Exchange"
          width="90%"
          onClose={onClose}
          visible={visible}
        >
          <Spin spinning={fullpageloading}>{renderData()}</Spin>
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    courier: state.settings.deliverytype,
  };
};

export default connect(mapStateToProps, {
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateVariation,
  updateInvoiceItem,
  deleteInvoiceItem,
  getdeliverytype,
  getAllAccount,
  getSpecificInvoice,
  updateService,
  deleteService,
  getInvoiceMeasurement,
  getSpecificMeasurementbycontact,
})(Quickview);
